import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ReviewService {
    constructor(private http: HttpClient) { }

    addReview(productId,review){
        return this.http.post<any>(`${environment.apiUrl}/reviews/add-review/${productId}`,review);
    }
}
